// Overnight dApp is discontinued. Every former dApp entry point on the landing
// leads to the documentation page describing how to withdraw funds via contracts.
export const DOCS_URL = 'https://docs.overnight.fi/';
export const WITHDRAW_DOCS_URL = 'https://docs.overnight.fi/core-concept/withdraw';
